import React, { useState, useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
// import Divider from "@mui/material/Divider";
// import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import OrganizationService from "../api/organization";
import Loading from "../common/loading";
import EnhancedTableHead from "../common/EnhancedTableHead";
import SubOrganizationTableRow from "./subOrganizationTableRow";
import SearchInput from "../common/searchInput";
import { getUrlVars } from "../utils/systemInfo";
import StyledTypography from "../common/StyledTypography";

import { setSubOrganizationsData } from "../store/subOrganizationsSlice";
import PropTypes from "prop-types";

const StyledTablePagination = styled((props) => <TablePagination {...props} />)(
  ({ theme }) => ({
    color: theme.palette.custom.text,
    "& .MuiTablePagination-selectIcon": {
      color: theme.palette.custom.text,
    },
  })
);
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
const headCells = [
  {
    id: "fullName",
    numeric: false,
    disablePadding: true,
    label: "FullName",
    sort: true,
  },
  {
    id: "shortName",
    numeric: false,
    disablePadding: true,
    label: "ShortName",
    sort: true,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    sort: true,
  },
  {
    id: "linkUid",
    numeric: false,
    disablePadding: false,
    label: "View",
    sort: true,
  },
];

export default function DeviceSignalsTab() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const organziation = useSelector(({ organziation }) => organziation);
  const subOrganizations = useSelector(
    ({ subOrganizations }) => subOrganizations
  );
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("fullName");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    Number(localStorage.getItem("rowsPerPage")) ?? 10
  );
  const [searchText, setSearchText] = useState("");
  const [selected, setSelected] = useState([]);
  const [subOrganizationsArray, setSubOrganizationsArray] = useState(undefined);
  const [loadingValue, setLoadingValue] = useState(true);
  const OrganizationId = String(getUrlVars()["id"]);
  useEffect(() => {
    getSubOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organziation, OrganizationId]);
  function getSubOrganizations() {
    if (organziation) {
      setSubOrganizationsArray(null);
      const apiKey = localStorage.getItem("apiKey");
      OrganizationService.GetSubOrganizationList({
        primary_profile_uid: OrganizationId,
        apiKey,
      })
        .then((json) => {
          if (
            json &&
            json.operation_profile_link &&
            json.operation_profile_link.length > 0
          ) {
            setSubOrganizationsArray(json.operation_profile_link[0]?.primary);
            let opsumInputObj = {
              jsonCurrent: json.operation_profile_link[0]?.primary,
              newSearchText: "",
            };
            opsumInputObj.newSearchText = searchText;
            dispatch(setSubOrganizationsData(opsumInputObj));
          }
          setLoadingValue(false);
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }
  }
  function handleSearch(ev) {
    setPage(0);
    setLoadingValue(true);
    const newSearchText = ev.target.value;
    setSearchText(newSearchText);
    let opsumInputObj = {
      jsonCurrent: subOrganizationsArray,
      newSearchText: "",
    };
    opsumInputObj.newSearchText = newSearchText;
    dispatch(setSubOrganizationsData(opsumInputObj));
    setLoadingValue(false);
  }
  const visibleRows = useMemo(
    () => {
      if (subOrganizations && subOrganizations.length > 0) {
        return stableSort(
          subOrganizations,
          getComparator(order, orderBy)
        ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      } else {
        return [];
      }
    },
    [order, orderBy, page, rowsPerPage, subOrganizations]
    //[page, rowsPerPage, safety],
  );
  const isSelected = (fullName) => selected.indexOf(fullName) !== -1;
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem("rowsPerPage", event.target.value);
    setPage(0);
  };
  const handleClick = (event, fullName) => {
    const selectedIndex = selected.indexOf(fullName);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, fullName);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  return (
    <Box
      sx={{
        p: "12px",
        mt: "8px",
        minHeight: "90vh",
        height: "fit-content",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "block", sm: "center" },
          height: "64px",
        }}
      >
        <Box sx={{ display: { xs: "block", sm: "flex" } }}>
          <Typography
            sx={{
              fontSize: "45px",
              mb: 0,
              color: theme.palette.custom.borderColor,
            }}
            variant="h2"
            gutterBottom
          >
            {t("Signals")}
          </Typography>
        </Box>
      </Box>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      /> */}

      <SearchInput searchText={searchText} handleSearch={handleSearch} />
      {loadingValue ? (
        <Box sx={{ height: "30vh", pt: "10%" }}>
          <Loading />
        </Box>
      ) : (
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            //  size={'medium'}
          >
            <EnhancedTableHead
              hideCheck={true}
              headCells={headCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />

            <TableBody>
              {subOrganizations &&
              subOrganizations.length > 0 &&
              visibleRows.length ? (
                visibleRows.map((row, index) => {
                  const isItemSelected = isSelected(row.fullName);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <SubOrganizationTableRow
                      handleGetSubOrganizationAgain={getSubOrganizations}
                      key={row.fullName}
                      row={row}
                      handleClick={handleClick}
                      isItemSelected={isItemSelected}
                      labelId={labelId}
                    />
                  );
                })
              ) : (
                <StyledTypography>{t("No entries found")}</StyledTypography>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <StyledTablePagination
        SelectProps={{
          inputProps: {
            MenuProps: {
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.secondary.dark,
                  color: theme.palette.custom.text,
                  "& .MuiMenuItem-root.Mui-selected": {
                    backgroundColor: theme.palette.custom.borderColor,
                  },
                  "& .MuiMenuItem-root:hover": {
                    backgroundColor: "blue",
                  },
                  "& .MuiMenuItem-root.Mui-selected:hover": {
                    backgroundColor: "blue",
                  },
                },
              },
            },
          },
        }}
        rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
        component="div"
        count={
          subOrganizations && subOrganizations.length > 0
            ? subOrganizations.length
            : 0
        }
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
DeviceSignalsTab.propTypes = {
  machineType: PropTypes.string,
};
